// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useEffect, useRef, useState } from "react";
/**
 * The width of an element, so a widget can follow the room it has rather
 * than the window's: attach the returned ref; the width is null until the
 * element is measured.
 */
export var useContainerWidth = function () {
    var _a = useState(null), width = _a[0], setWidth = _a[1];
    var observer = useRef(null);
    var ref = useCallback(function (element) {
        var _a;
        (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        observer.current = null;
        if (!element)
            return;
        setWidth(Math.round(element.getBoundingClientRect().width));
        if (typeof ResizeObserver === "undefined")
            return;
        observer.current = new ResizeObserver(function (_a) {
            var entry = _a[0];
            if (entry)
                setWidth(Math.round(entry.contentRect.width));
        });
        observer.current.observe(element);
    }, []);
    useEffect(function () { return function () { var _a; return (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect(); }; }, []);
    return [ref, width];
};
